import React from 'react';
import StatCard from './StatCard';

interface StatData {
  label: string;
  value: number;
  unit?: string;
  icon?: React.ReactNode;
  status?: 'good' | 'fair' | 'attention' | 'monitor';
}

interface HealthSummaryProps {
  stats: StatData[];
}

const HealthSummary: React.FC<HealthSummaryProps> = ({ stats }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    }}>
      {/* Title */}
      <h2 style={{
        fontFamily: 'BT Beau Sans, sans-serif',
        fontWeight: 800,
        fontSize: '20px',
        lineHeight: '30px',
        textAlign: 'center',
        color: '#007BC2',
        margin: 0
      }}>
        TỔNG HỢP TÌNH TRẠNG SỨC KHỎE
      </h2>

      {/* Stats Grid */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        justifyContent: 'center',
        flexWrap: 'wrap'
      }}>
        {stats.map((stat, index) => (
          <StatCard
            key={index}
            label={stat.label}
            value={stat.value}
            unit={stat.unit}
            icon={stat.icon}
            status={stat.status}
          />
        ))}
      </div>
    </div>
  );
};

export default HealthSummary;
